import { useViewport } from 'contexts/viewport';
import { useEffect, useState } from 'react';

const getClampedVerticalPosition = ({ bottomPadding, elementHeight, nextY, topPadding, viewportHeight }) => {
    const maxY = Math.max(topPadding, viewportHeight - elementHeight - bottomPadding);

    return Math.min(Math.max(nextY, topPadding), maxY);
};

const useRightEdgeLauncherPosition = ({
    bottomPadding,
    height,
    initialY,
    onVerticalPositionChange,
    rightOffset,
    topPadding,
    verticalPosition: controlledVerticalPosition,
    width,
}) => {
    const { height: viewportHeight, width: viewportWidth } = useViewport();
    const [uncontrolledVerticalPosition, setUncontrolledVerticalPosition] = useState(() =>
        getClampedVerticalPosition({
            bottomPadding,
            elementHeight: height,
            nextY: initialY,
            topPadding,
            viewportHeight,
        })
    );
    const verticalPosition = controlledVerticalPosition ?? uncontrolledVerticalPosition;
    const setVerticalPosition = onVerticalPositionChange ?? setUncontrolledVerticalPosition;

    useEffect(() => {
        const clampedVerticalPosition = getClampedVerticalPosition({
            bottomPadding,
            elementHeight: height,
            nextY: verticalPosition,
            topPadding,
            viewportHeight,
        });

        if (clampedVerticalPosition !== verticalPosition) {
            setVerticalPosition(clampedVerticalPosition);
        }
    }, [bottomPadding, height, setVerticalPosition, topPadding, verticalPosition, viewportHeight]);

    useEffect(() => {
        if (controlledVerticalPosition !== undefined) return;

        setUncontrolledVerticalPosition((currentY) =>
            getClampedVerticalPosition({
                bottomPadding,
                elementHeight: height,
                nextY: currentY,
                topPadding,
                viewportHeight,
            })
        );
    }, [bottomPadding, controlledVerticalPosition, height, topPadding, viewportHeight]);

    return {
        position: {
            x: Math.max(0, viewportWidth - width - rightOffset),
            y: verticalPosition,
        },
        onDragStop: (_, dragData) => {
            const nextVerticalPosition = getClampedVerticalPosition({
                bottomPadding,
                elementHeight: height,
                nextY: dragData.y,
                topPadding,
                viewportHeight,
            });

            setVerticalPosition(nextVerticalPosition);
        },
    };
};

export default useRightEdgeLauncherPosition;
